import * as Factory from 'factory.ts'
import faker from 'faker'

import {
  type Contract,
  type ContractAttachment,
  type ContractDpsRequest,
} from '@webapp/models'
import { ContractRenewalTerms, ContractStatuses } from '@webapp/models/enums'
import { DpsRequestStatuses } from '@webapp/models/enums/DpsRequestStatus'
import { CurrencyMock } from './currency.factory'
import { PaymentTermMock } from './paymentTerm.factory'
import { VendorMock } from './vendor.factory'

export const ContractMock = Factory.Sync.makeFactory<Contract>({
  id: Factory.each(() => faker.random.number()),
  uuid: Factory.each(() => faker.random.uuid()),
  is_active: true,
  name: Factory.each(() => faker.random.words(3)),
  description: Factory.each(() => faker.random.words(5)),
  renewal_term: ContractRenewalTerms.YEAR,
  renewal_length: 10,
  is_auto_renew: false,
  start_date: Factory.each(() => faker.date.past().toISOString()),
  end_date: Factory.each(() => faker.date.future().toISOString()),
  initial_start_date: Factory.each(() => faker.date.past().toISOString()),
  initial_end_date: Factory.each(() => faker.date.past().toISOString()),
  status: ContractStatuses.ACTIVE,
  value: Factory.each(() => faker.finance.amount()),
  vendor: Factory.each(() => VendorMock.build()),
  owner: Factory.each(() => ({
    id: faker.random.number(),
    first_name: faker.name.firstName(),
    last_name: faker.name.lastName(),
    email: faker.internet.email(),
    profile_image: faker.image.animals(),
    user_id: faker.random.number(),
  })),
  creator: Factory.each(() => ({
    id: faker.random.number(),
    first_name: faker.name.firstName(),
    last_name: faker.name.lastName(),
    email: faker.internet.email(),
    profile_image: faker.image.animals(),
    user_id: faker.random.number(),
  })),
  currency: CurrencyMock.build(),
  payment_terms: PaymentTermMock.build(),
  updated_at: Factory.each(() => faker.date.past().toISOString()),
  created_at: Factory.each(() => faker.date.past().toISOString()),
  spent_amount: Factory.each(() => faker.finance.amount()),
  remaining_amount: '',
  purchase_orders: [],
}).withDerivation2(
  ['value', 'spent_amount'],
  'remaining_amount',
  (value, spentAmount) => {
    return (Number(value) - Number(spentAmount)).toString()
  }
)

export const ContractAttachmentMock =
  Factory.Sync.makeFactory<ContractAttachment>({
    created_at: faker.date.past().toISOString(),
    description: faker.random.words(),
    file: Factory.each(() => `attachments_${faker.random.uuid()}`),
    id: Factory.each(() => faker.random.number()),
    length: faker.random.number(),
    mimetype: 'image/png',
    name: Factory.each(
      (index) => `attachment_${index}_${faker.system.commonFileName('png')}`
    ),
    sha1_hash: '',
    uuid: Factory.each(() => faker.random.alphaNumeric(32)),
    user: Factory.each(() => ({
      id: faker.random.number(),
      first_name: faker.name.firstName(),
      last_name: faker.name.lastName(),
      email: faker.internet.email(),
      profile_image: faker.image.animals(),
      user_id: faker.random.number(),
    })),
  })

export const ContractDpsRequestMock =
  Factory.Sync.makeFactory<ContractDpsRequest>({
    status: DpsRequestStatuses.PENDING,
  })
